// reducers/chat/lexCB.js

// --- ALL ---

export function lexCBHasErrored(state = false, action) {
    switch (action.type) {
      case 'lexCB_HAS_ERRORED':
        return action.hasErrored;
      default:
        return state;
    }
  }
  
  export function lexCBIsLoading(state = false, action) {
    switch (action.type) {
      case 'lexCB_IS_LOADING':
        return action.isLoading;
      default:
        return state;
    }
  }
  
  export function lexCB(state = {}, action) {
    switch(action.type) {
      case 'lexCB_FETCH_DATA_SUCCESS':
        return action.response;
      default:
        return state;
    }
  }